import { useStorage } from '@vueuse/core'
import { middlewareInstructions } from './types'

export default function hasCheckoutId(): middlewareInstructions {
  const id = useStorage('checkout-id', '')
  if (!id.value) return { to: { name: 'checkout-sign-in' }, actions: 'logout' }
  return { to: { name: '' } }
}
